export class ApiError extends Error {
  protected code = 'UNKNOWN_ERROR';
  protected data: any = null;

  fromError(error: Error): ApiError {
    this.message = error.message;
    this.stack = error.stack;
    if (error.extensions && error.extensions.code && typeof error.extensions.code === 'string') {
      this.code = error.extensions.code;
      this.data = error.extensions.data;
    }
    if (error.extensions && error.extensions.data) {
      this.data = error.extensions.data;
    }
    return this;
  }

  setCode(code: string): ApiError {
    this.code = code;
    return this;
  }

  getCode(): string {
    return this.code;
  }

  getMessage(): string {
    return this.message;
  }
}
